import { createSelector } from '@ngrx/store'
import { AppState } from '../index'

export const selectLegacyState = (state: AppState) => state.legacy

export const selectSelectedLegacyClientId = createSelector(
  selectLegacyState,
  (state) => state.selectedClientId,
)

export const selectSelectedLegacyYearId = createSelector(
  selectLegacyState,
  (state) => state.selectedYearId,
)

export const selectSelectedLegacyProgramId = createSelector(
  selectLegacyState,
  (state) => state.selectedProgramId,
)

export const selectSelectedLegacyStructureId = createSelector(
  selectLegacyState,
  (state) => state.selectedStructureId,
)

export const selectLegacyContextLoaded = createSelector(
  selectLegacyState,
  (state) => state.contextLoaded,
)

export const selectLegacyClientName = createSelector(selectLegacyState, (state) => state.clientName)

export const selectLegacyYearLabel = createSelector(selectLegacyState, (state) => state.yearLabel)

export const selectLegacyProgramName = createSelector(
  selectLegacyState,
  (state) => state.programName,
)
